"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallcenterByLinkCredentialsToJSON = exports.CallcenterByLinkCredentialsFromJSONTyped = exports.CallcenterByLinkCredentialsFromJSON = void 0;
var runtime_1 = require("../runtime");
function CallcenterByLinkCredentialsFromJSON(json) {
    return CallcenterByLinkCredentialsFromJSONTyped(json, false);
}
exports.CallcenterByLinkCredentialsFromJSON = CallcenterByLinkCredentialsFromJSON;
function CallcenterByLinkCredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'agentId': json['agentId'],
        'customerNo': !(0, runtime_1.exists)(json, 'customerNo') ? undefined : json['customerNo'],
        'timestamp': json['timestamp'],
        'hmac': json['hmac'],
        'toReturnToInCaseOfError': json['toReturnToInCaseOfError'],
    };
}
exports.CallcenterByLinkCredentialsFromJSONTyped = CallcenterByLinkCredentialsFromJSONTyped;
function CallcenterByLinkCredentialsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'agentId': value.agentId,
        'customerNo': value.customerNo,
        'timestamp': value.timestamp,
        'hmac': value.hmac,
        'toReturnToInCaseOfError': value.toReturnToInCaseOfError,
    };
}
exports.CallcenterByLinkCredentialsToJSON = CallcenterByLinkCredentialsToJSON;
//# sourceMappingURL=CallcenterByLinkCredentials.js.map